import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Menu, LogOut, User as UserIcon } from "lucide-react";
import { useState } from "react";

const links = [
  { to: "/", label: "Ana Sayfa", testid: "nav-home" },
  { to: "/hakkimda", label: "Hakkımda", testid: "nav-about" },
  { to: "/alet-edevat", label: "Stüdyo", testid: "nav-gear" },
  { to: "/referanslarim", label: "Referanslarım", testid: "nav-references" },
  { to: "/siparis", label: "Sipariş Ver", testid: "nav-order" },
  { to: "/enstrumanlar", label: "Enstrümanistler", testid: "nav-players" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-white/5 backdrop-blur-md" style={{ background: "rgba(11,12,16,0.75)" }} data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-logo">
          <span className="font-display font-bold text-xl tracking-tight">
            zafertufan<span className="text-cyan-400">.com</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `px-3 py-2 text-sm rounded-full transition-colors ${
                  isActive ? "text-cyan-300" : "text-slate-300 hover:text-white"
                }`
              }
              end
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          {user ? (
            <div className="hidden md:flex items-center gap-2">
              {user.is_admin && (
                <NavLink to="/admin" data-testid="nav-admin" className="mono-caps px-3 py-2 rounded-full border border-amber-400/30 text-amber-400 hover:text-amber-300">
                  Admin
                </NavLink>
              )}
              <NavLink to="/dashboard" data-testid="nav-dashboard" className="mono-caps px-3 py-2 rounded-full text-cyan-300 hover:text-cyan-200">
                Panel
              </NavLink>
              <div className="flex items-center gap-2 pl-2 border-l border-white/10">
                {user.picture ? (
                  <img src={user.picture} alt="" className="w-8 h-8 rounded-full" />
                ) : (
                  <UserIcon className="w-5 h-5 text-slate-400" />
                )}
                <button onClick={async () => { await logout(); navigate("/"); }}
                  data-testid="logout-btn"
                  className="text-slate-400 hover:text-white p-1">
                  <LogOut className="w-4 h-4" />
                </button>
              </div>
            </div>
          ) : (
            <Link to="/login" data-testid="login-cta" className="btn-cyan text-sm hidden md:inline-block">
              Google ile Giriş
            </Link>
          )}
          <button
            className="md:hidden p-2 text-slate-200"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="menu"
          >
            <Menu className="w-6 h-6" />
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/5 px-4 py-4 space-y-2" data-testid="mobile-menu">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="block py-2 text-slate-300">
              {l.label}
            </NavLink>
          ))}
          {user ? (
            <>
              {user.is_admin && <NavLink to="/admin" onClick={() => setOpen(false)} className="block py-2 text-amber-300">Admin Paneli</NavLink>}
              <NavLink to="/dashboard" onClick={() => setOpen(false)} className="block py-2 text-cyan-300">Müşteri Paneli</NavLink>
              <button onClick={async () => { await logout(); setOpen(false); navigate("/"); }} className="block py-2 text-slate-400">Çıkış</button>
            </>
          ) : (
            <Link to="/login" onClick={() => setOpen(false)} className="block py-2 text-cyan-300">Google ile Giriş</Link>
          )}
        </div>
      )}
    </header>
  );
}
